import React from 'react';
import { Button } from '../components/ui/Button';
import { useLanguage } from '../contexts/LanguageContext';

export const RulesScreen = ({ onBack }) => {
    const { t } = useLanguage();

    return (
        <div className="flex flex-col h-full w-full px-6 pt-6 pb-6 gap-6 overflow-hidden relative z-10">
            {/* Header */}
            <div className="flex items-center justify-between shrink-0 mb-1">
                <Button
                    variant="secondary"
                    size="sm"
                    onClick={onBack}
                    className="w-10 h-10 p-0 rounded-full flex items-center justify-center bg-white/5 border border-white/10 text-slate-400 hover:text-white hover:bg-white/10"
                >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 19l-7-7 7-7" />
                    </svg>
                </Button>
                <h1 className="text-xl font-bold text-white tracking-widest uppercase text-glow">{t('rules_title')}</h1>
                <div className="w-10" />
            </div>

            <div className="flex-1 overflow-y-auto space-y-6 min-h-0 pr-2 custom-scrollbar">

                {/* Intro */}
                <div className="text-center space-y-2">
                    <div className="w-16 h-16 mx-auto bg-gradient-to-br from-cyan-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-[0_0_20px_rgba(6,182,212,0.4)] rotate-3">
                        <span className="text-3xl">🤔</span>
                    </div>
                    <h2 className="text-lg font-bold text-white">{t('rules_intro_title')}</h2>
                    <p className="text-sm text-slate-400 leading-relaxed">
                        {t('rules_intro_desc')}
                    </p>
                </div>

                {/* Steps */}
                <div className="space-y-3">
                    <RuleCard
                        icon="💬"
                        title={t('rule_1_title')}
                        desc={t('rule_1_desc')}
                    />
                    <RuleCard
                        icon="🕵️‍♂️"
                        title={t('rule_2_title')}
                        desc={t('rule_2_desc')}
                    />
                    <RuleCard
                        icon="🗳️"
                        title={t('rule_3_title')}
                        desc={t('rule_3_desc')}
                    />
                </div>

                {/* Scoring - Compact */}
                <div className="bg-white/5 border border-white/10 rounded-2xl p-3 flex flex-col gap-2">
                    <h3 className="text-xs font-bold text-white uppercase tracking-wider text-center mb-1">{t('rules_scoring')}</h3>

                    <div className="flex items-center justify-between text-sm bg-white/5 p-2 rounded-lg">
                        <span className="text-slate-300 text-xs">{t('rules_win')}</span>
                        <span className="font-bold text-green-400 drop-shadow-[0_0_8px_rgba(74,222,128,0.4)]">+20</span>
                    </div>

                    <div className="flex items-center justify-between text-sm bg-white/5 p-2 rounded-lg">
                        <span className="text-slate-300 text-xs">{t('rules_loss')}</span>
                        <span className="font-bold text-red-400 drop-shadow-[0_0_8px_rgba(248,113,113,0.4)]">-15</span>
                    </div>
                </div>

                {/* Tips */}
                <div className="bg-cyan-900/20 border border-cyan-500/20 rounded-xl p-4">
                    <p className="text-xs text-cyan-200 leading-relaxed">
                        <strong className="text-cyan-400">{t('rules_tip_title')}</strong> {t('rules_tip_desc')}
                    </p>
                </div>

                <div className="h-4" /> {/* Bottom spacer */}
            </div>

            <Button variant="primary" className="w-full shrink-0" onClick={onBack}>
                {t('rules_understood')}
            </Button>
        </div>
    );
};

const RuleCard = ({ icon, title, desc }) => (
    <div className="flex gap-4 p-4 rounded-2xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-white/10 transition-colors">
        <div className="text-2xl shrink-0 grayscale opacity-80">{icon}</div>
        <div className="space-y-1">
            <h3 className="font-bold text-white text-sm">{title}</h3>
            <p className="text-xs text-slate-400 leading-relaxed">{desc}</p>
        </div>
    </div>
);
